'use strict';

var _regeneratorRuntime = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var configure = require('../lib/configure.js');

var resolve = require('../lib/resolve.js');

var first = require('it-first');

var last = require('it-last');

var errCode = require('err-code');

var get = require('../block/get.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var first__default = /*#__PURE__*/_interopDefaultLegacy(first);

var last__default = /*#__PURE__*/_interopDefaultLegacy(last);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var createGet = function createGet(codecs, options) {
  var fn = configure.configure(function (api, opts) {
    var getBlock = get.createGet(opts);

    var get$1 = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid) {
        var options,
            entry,
            result,
            codec,
            block,
            node,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

                if (!options.path) {
                  _context.next = 16;
                  break;
                }

                if (!options.localResolve) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return first__default["default"](resolve.resolve(cid, options.path, codecs, getBlock, options));

              case 5:
                _context.t0 = _context.sent;
                _context.next = 11;
                break;

              case 8:
                _context.next = 10;
                return last__default["default"](resolve.resolve(cid, options.path, codecs, getBlock, options));

              case 10:
                _context.t0 = _context.sent;

              case 11:
                entry = _context.t0;
                result = entry;

                if (result) {
                  _context.next = 15;
                  break;
                }

                throw errCode__default["default"](new Error('Not found'), 'ERR_NOT_FOUND');

              case 15:
                return _context.abrupt("return", result);

              case 16:
                _context.next = 18;
                return codecs.getCodec(cid.code);

              case 18:
                codec = _context.sent;
                _context.next = 21;
                return getBlock(cid, options);

              case 21:
                block = _context.sent;
                node = codec.decode(block);
                return _context.abrupt("return", {
                  value: node,
                  remainderPath: ''
                });

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function get$1(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    return get$1;
  });
  return fn(options);
};

exports.createGet = createGet;